"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  getStorybookAdapter: true
};
exports.getStorybookAdapter = void 0;

var _api = require("../api");

var _mockData = require("./mockData");

Object.keys(_mockData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _mockData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _mockData[key];
    }
  });
});

var getStorybookAdapter = function getStorybookAdapter(userToken, guid) {
  return function (config) {
    var _config$url, _data$credentials;

    var path = (_config$url = config.url) === null || _config$url === void 0 ? void 0 : _config$url.split('/')[1];
    var data = config.data ? JSON.parse(config.data) : {};
    var response = {};

    switch (path) {
      case 'institutions':
        response = _mockData.mockInstitutionList;
        break;

      case 'cs_preload':
        response = {
          institution: _mockData.loginPreloadInstitutionMock,
          user_token: userToken
        };
        break;

      case 'cs_login':
        if (((_data$credentials = data.credentials) === null || _data$credentials === void 0 ? void 0 : _data$credentials['with-mfa']) === 'with') {
          response = {
            mfa: _mockData.mockLoginMfaResponseCba.mfa,
            user_token: userToken
          };
        } else {
          response = {
            accounts: _mockData.mockLoginResponse.accounts,
            user_token: userToken
          };
        }

        break;

      case 'cs_mfa':
        response = {
          accounts: _mockData.mockLoginResponse.accounts,
          user_token: userToken
        };
        break;

      case 'cs_export':
        response = {
          customerSelectedCategories: _mockData.mockGetStatementDataResponse.customerSelectedCategories,
          user_token: userToken
        };
        break;
    }

    return (0, _api.successAdapter)(response)(config);
  };
};

exports.getStorybookAdapter = getStorybookAdapter;